<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('picture.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'pictures' }">{{ $t('picture.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'pictures-search' }">{{ $t('picture.list.search.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-nav pills fill>
          <b-nav-item
            :to="{ name: 'pictures', params: { group: 'applicable' } }"
          >{{ $t('picture.list.application.title') }}</b-nav-item>
          <b-nav-item
            :to="{ name: 'pictures', params: { group: 'downloadable' } }"
          >{{ $t('picture.list.download.title') }}</b-nav-item>
          <b-nav-item :to="{ name: 'pictures-search' }" active>{{ $t('picture.list.search.title') }}</b-nav-item>
        </b-nav>
      </div>
    </div>
    <b-overlay :show="is_loading" rounded="sm" opacity="0.6">
      <div class="row mt-3">
        <div class="col-12">
          <application-list-button-toolbar></application-list-button-toolbar>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <b-form @submit="submitKeyword">
            <b-input-group size="lg">
              <b-form-input
                style="border-color: black; color: black"
                :placeholder="$t('picture.list.search.search-bar.keyword-inputor.hint')"
                v-model="keyword"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  type="submit"
                  variant="primary"
                >{{ $t('picture.list.search.search-bar.search-button.label') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
        </div>
      </div>
      <div class="row mt-3" v-if="this.search_completed && pictures.length > 0">
        <div class="col-12">
          <b-form-select v-model="per_page" :options="per_page_options"></b-form-select>
        </div>
      </div>
      <picture-card-list :pictures="pictures" v-if="this.search_completed && pictures.length > 0"></picture-card-list>
      <div class="row" v-if="this.search_completed && pictures.length > 0">
        <div class="col-12">
          <b-pagination
            size="lg"
            align="center"
            v-model="page"
            :total-rows="total"
            :per-page="per_page"
            @change="pageChange"
          ></b-pagination>
        </div>
      </div>
      <div class="row mt-3" v-if="this.search_completed && pictures.length === 0">
        <div class="col-12">
          <h5 class="text-danger font-weight-bold">{{ $t('picture.list.search.message.no-result') }}</h5>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="arrow-clockwise" font-scale="5" animation="spin-pulse"></b-icon>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonGroupPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { ButtonToolbarPlugin } from 'bootstrap-vue'
import { FormInputPlugin } from 'bootstrap-vue'
import { FormPlugin } from 'bootstrap-vue'
import { FormSelectPlugin } from 'bootstrap-vue'
import { InputGroupPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { NavPlugin } from 'bootstrap-vue'
import { OverlayPlugin } from 'bootstrap-vue'
import { PaginationPlugin } from 'bootstrap-vue'

import ApplicationListButtonToolbar from '@/components/button-toolbars/application-list-button-toolbar/ApplicationListButtonToolbar'
import PictureCardList from '@/components/lists/PictureCardList'
import PictureEfileList from '@/components/lists/PictureEfileList'
import PictureInfo from '@/components/info/PictureInfo'

import i18n from '@/plugins/i18n.js'

import PictureApiService from '@/services/budaedu-api-services/picture-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(ButtonPlugin)
Vue.use(ButtonToolbarPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormPlugin)
Vue.use(FormSelectPlugin)
Vue.use(InputGroupPlugin)
Vue.use(ModalPlugin)
Vue.use(NavPlugin)
Vue.use(OverlayPlugin)
Vue.use(PaginationPlugin)

Vue.use(PictureApiService)

export default {
  i18n,
  name: 'pictures',
  props: {
    // 
  },
  data() {
    return {
      is_loading: false,
      keyword: '',
      search_completed: false,
      pictures: [],
      total: 0,
      per_page: 30,
      page: 1,
      picture: {},
      picture_downloadable_efile: null,
      picture_printable_efile: null
    }
  },
  computed: {
    per_page_options() {
      return [
        { value: 30, text: this.$t('paginator.items-per-page-selector.option.label', { size: 30 }) },
        { value: 50, text: this.$t('paginator.items-per-page-selector.option.label', { size: 50 }) },
        { value: 100, text: this.$t('paginator.items-per-page-selector.option.label', { size: 100 }) }
      ]
    },
    /**
     * 將使用者輸入的關鍵字（以空格隔開）解析為陣列
     * 同時支援半形空格、全形空格，並自動 trim 與合併連續空白
     */
    parsedKeywords() {
      return this.keyword.trim().split(/[\s\u3000]+/).filter(k => k.length > 0)
    }
  },
  watch: {
    per_page(new_value, old_value) {
      this.page = 1
      this.pictures = []
      this.setPicturesAndPaging()
    }
  },
  methods: {
    submitKeyword(event) {
      event.preventDefault()
      this.page = 1
      this.setPicturesAndPaging()
    },
    pageChange(page) {
      this.page = page
      this.setPicturesAndPaging()
    },
    async setPicturesAndPaging() {
      this.search_completed = false
      this.is_loading = true
      this.pictures = []
      try {
        let items = {}
        let preview = { url: 'img/common.jpg' }
        const additional = `filter[have_efile]&order=latest_storage_date,desc|created_at,desc&per_page=${this.per_page}&page=${this.page}`

        if (this.parsedKeywords.length > 1) {
          // 多關鍵字：以逗號分隔傳入 filter[of_keywords]（AND 邏輯）
          items = await this.$pictureApiService.queryByKeywords(
            this.parsedKeywords.join(','),
            additional
          )
        } else if (this.parsedKeywords.length === 1) {
          // 單一關鍵字：維持原有 filter[of_keyword]
          items = await this.$pictureApiService.queryByKeyword(
            this.parsedKeywords[0],
            additional
          )
        } else {
          items = await this.$pictureApiService.query(additional)
        }

        const previewPromises = items.data.map(async (picture) => {
          picture.preview = await this.$pictureApiService.getPreviewableEfile(picture, preview)
        })
        await Promise.all(previewPromises);

        this.pictures = items.data
        this.total = items.meta.total
      } finally {
        this.is_loading = false
        this.search_completed = true
      }
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    ApplicationListButtonToolbar,
    PictureCardList,
    PictureEfileList,
    PictureInfo
  },
  metaInfo() {
    return {
      title: this.$t('picture.list.search.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>